import { render, staticRenderFns } from "./ChangeNotifyRole.vue?vue&type=template&id=b0727c5c"
import script from "./ChangeNotifyRole.vue?vue&type=script&lang=js"
export * from "./ChangeNotifyRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports